module.exports = __webpack_public_path__ + "img/authentication-selected-white.56f1284b.png";